import React, { useState } from "react";
import CloseEye from "./../../svgs/CloseEye.svg";
import OpenEye from "./../../svgs/OpenEye.svg";

export default function PasswordInput({ className, isLeft, ...props}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={isOpen ? "text" : "password"}
        className={`shadow-sm border-2 border-secondary text-gray-900 sm:text-sm rounded-lg transition-all duration-300 focus:border-primary block w-full p-2.5 outline-none ${className}`}
      />
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`absolute top-2 ${isLeft ? "left-4" : "right-4"}  cursor-pointer`}
        type="button"
      >
        {isOpen ? (
          <img src={OpenEye} alt={"Open Eye"} width={24} height={24} />
        ) : (
          <img src={CloseEye} alt={"Close Eye"} width={24} height={24} />
        )}
      </button>
    </div>
  );
}